/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/require-default-props */
import PhoneCard from 'components/atoms/phone_card';
import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { BiddingData } from 'store/modules/bidding_store/types';
import MonitoringPortals from 'services/monitoring_portals';
import companyId from 'services/company_id';
import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';
import { useDispatch, useSelector } from 'react-redux';
import RobotCreateProposalButton from 'components/atoms/robot_proposal_button';
import BiddingCommentsList from 'components/organisms/bidding_comments_list';
import MonitoreButton from 'components/atoms/monitore_button';
import ManagementButton from 'components/atoms/management_button/management_button';
import BiddingAttachmentList from 'components/molecules/bidding_attachment_list';
import ManagementTask from 'components/molecules/management_task';
import MapLink from 'components/atoms/map_link';
import { PanelState } from 'store/modules/panel_store/types';
import ModalOrganDetails from 'components/molecules/modal_organ_details';
import ManagementRemoveBidding from 'components/atoms/management_remove_bidding';
import { ManagementState } from 'store/modules/management_store/types';
import { BulletinBiddingsTypes, BulletinsState } from 'store/modules/bulletins_store/types';
import _ from 'underscore';
import RobotComprasnetWarning from 'components/atoms/robot_comprasnet_warning';
import HighlightedText from 'components/atoms/highlighted_text';
import { solicitarEdital } from 'store/modules/bidding_store/actions';
import { getBiddingSummary } from 'store/modules/management_store/actions';
import useRefetchOnModalMutation from 'hooks/useRefetchOnModalMutation';
import createTrack from 'services/actions/tracker_actions';
import { track } from 'services/tracking';
import SquareLoader from 'components/atoms/square_loader';
import BiddingChatButton from 'components/atoms/bidding_chat_button';
import BiddingSummaryButton from 'components/atoms/bidding_summary_button';
import BiddingHeaderNew from 'components/atoms/bidding_header_new';
import ClipboardIcon from 'components/atoms/clipboard_icon';
import BiddingItems from 'components/atoms/bidding_items';
import BiddingGuaranteeInsurance from 'components/atoms/bidding_guarantee_insurance';
import Capag from 'components/atoms/capag';
import iconClock from 'assets/images/icon-clock.svg';
import ImminenceDate from 'components/atoms/imminence_date';
import MatchCompatibilityBar from 'components/molecules/match_compatibility_bar';
import BlurredContent from 'components/atoms/blurred_content';
import useGuaranteeInsurance from 'hooks/useGuaranteeInsurance';
import useOnlyConlicitaseg from 'hooks/useOnlyConlicitaseg';
import { Container } from './styles';
import BiddingInfoDropdown from '../../atoms/bidding_info_dropdown';
import { PortalImage } from '../monitoring_portals_list';

interface BiddingItemNewProps {
  bidding: BiddingData | BulletinBiddingsTypes;
  biddingIndex: number;
  isChecked: boolean;
  source?:
    | 'biddings'
    | 'management'
    | 'imminence'
    | 'bulletin'
    | 'biddingDetails'
    | 'share'
    | 'favorited';
  favoritedSource?: string;
  commentSource?: 'biddings' | 'management' | 'imminence' | 'bulletin';
  bulletinFilterId?: number;
  bulletinFilterIndex?: number;
  toggleSelected?: (id: number, updateAll?: boolean) => void;
  showMatch?: boolean;
  /** Vídeo e Personalizar só fazem sentido onde o modal de personalização existe (boletim). */
  matchActions?: boolean;
}

const NAVIGATION_KEYS = [
  'Tab',
  'Escape',
  'ArrowUp',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
  'Home',
  'End',
  'PageUp',
  'PageDown',
];

const BiddingItemNew = (props: BiddingItemNewProps) => {
  const {
    bidding,
    biddingIndex,
    isChecked,
    source = 'biddings',
    favoritedSource = 'bidding',
    commentSource = 'biddings',
    bulletinFilterId = 0,
    bulletinFilterIndex = 0,
    toggleSelected = () => {},
    showMatch = false,
    matchActions = true,
  } = props;
  const matchData = showMatch ? (bidding as BulletinBiddingsTypes).match : null;
  const dispatch = useDispatch();

  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);
  const { panel } = useSelector<ApplicationState, PanelState>((state) => state.session.panel);
  const { management, request } = useSelector<ApplicationState, ManagementState>(
    (state) => state.session.management,
  );
  const [taskCountRefreshed, setTaskCountRefreshed] = useState<boolean>(false);
  const { bulletins } = useSelector<ApplicationState, BulletinsState>(
    (state) => state.session.bulletins,
  );

  const [ItemsOpened, setItemsOpened] = useState<boolean>(false);
  const [BiddingInfoToggle, setBiddingInfoToggle] = useState<boolean>(false);
  const [modalManagementTaskOpened, setModalManagementTaskOpened] = useState<boolean>(false);
  const [taskType, setTaskType] = useState<string>('');
  const [modalOrganDetailsOpened, setModalOrganDetailsOpened] = useState<boolean>(false);
  const [modalRemoveBiddingOpened, setModalRemoveBiddingOpened] = useState<boolean>(false);
  const [modalRobotWarningOpened, setModalRobotWarningOpened] = useState<boolean>(false);
  const [statusTwoDays, setStatusTwoDays] = useState<boolean>(false);
  const [statusOneDay, setStatusOneDay] = useState<boolean>(false);
  const [statusDay, setStatusDay] = useState<boolean>(false);
  const portals = MonitoringPortals();
  const ALLOWED_ROBOT_PORTALS = [
    'Licitanet',
    'BLL Compras',
    'Bolsa Nacional de Compras (BNC)',
    'ComprasNet',
    'Portal de Compras Publicas',
    'ComprasNet DL',
  ];
  const [requestEdital, setRequestEdital] = useState(false);
  const [messageEditalSuccess, setMessageEditalSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [solicited, setSolicited] = useState(bidding?.has_requested_edital);

  const totalManagedTasks = () => {
    const biddingId = Number(bidding.bidding_id) || Number(bidding.id);
    const summaryTotal = management.bidding_summary?.[biddingId]?.total_managed_opened_tasks;
    if (taskCountRefreshed && summaryTotal != null) return summaryTotal;
    return (
      bidding.total_managed_opened_tasks ??
      summaryTotal ??
      management.managed.find((managed) => managed.id === biddingId)?.total_managed_opened_tasks ??
      0
    );
  };

  useRefetchOnModalMutation(
    modalManagementTaskOpened,
    [request.create_tasks?.loaded, request.create_progress?.loaded],
    () => {
      dispatch(
        getBiddingSummary(Number(bidding.bidding_id) || Number(bidding.id), companyId(profile)),
      );
      setTaskCountRefreshed(true);
    },
  );

  const isOnlyConlicitaseg = useOnlyConlicitaseg();

  const maybeBlur = (content: JSX.Element) =>
    isOnlyConlicitaseg ? <BlurredContent>{content}</BlurredContent> : content;

  const blockLocked = (event: React.SyntheticEvent) => {
    if (!isOnlyConlicitaseg) return;

    if (event.type === 'keydown' && NAVIGATION_KEYS.includes((event as React.KeyboardEvent).key))
      return;

    event.preventDefault();
    event.stopPropagation();
  };

  const guaranteeInsurance = useGuaranteeInsurance(bidding);

  useEffect(() => {
    if (requestEdital) setItemsOpened(false);
  }, [requestEdital]);

  useEffect(() => {
    if (ItemsOpened) setRequestEdital(false);
  }, [ItemsOpened]);

  const handleClickEdital = async (bidding_id: number | string) => {
    setLoading(true);
    try {
      createTrack(`${source} - Solicitou edital`);
      track('edital.solicitou', { fonte: source, bidding_id });
      await dispatch(solicitarEdital(bidding_id));
      setMessageEditalSuccess(true);
    } catch (error) {
      console.error('Erro ao solicitar edital:', error);
    } finally {
      setLoading(false);
      setSolicited(true);
      setRequestEdital(false);
    }
  };

  return (
    <Container className="row">
      <div className="col-12 p-0">
        <div
          className={`card shadow bidding rounded position-relative mb-5 ${
            isChecked ? 'bidding_selected' : 'd-print-none'
          }`}
        >
          <BiddingHeaderNew
            source={source}
            biddingId={bidding.bidding_id.toString() || bidding.id.toString()}
            biddingIndex={biddingIndex}
            isChecked={isChecked}
            toggleSelected={toggleSelected}
            isFavorited={bidding.favorited}
            contactList={bidding.favorited_by}
            favoritedSource={favoritedSource}
            bulletinFilterId={bulletinFilterId}
            isViewed={bidding.viewed_by_user}
            isViewedBy={bidding.viewed_by}
            situation={bidding?.bidding_grouping?.descricao}
            sessionStatus={bidding?.status_bidding_info?.[0]?.status_name}
            gestao={bidding.gestao}
          />
          <div className={`card-body p-4 ${bidding.viewed_by_user ? 'bidding-viewed' : ''}`}>
            {/* Só a Alta recebe selo; 'Média' cobre os scores antigos. */}
            {matchData && (matchData.prioridade === 'Alta' || matchData.prioridade === 'Média') && (
              <MatchCompatibilityBar match={matchData} showActions={matchActions} />
            )}
            <div className="tour-bidding-info">
              <div className="d-flex flex-column mb-2 bidding-info">
                <div className="d-flex">
                  <div className="bidding-info-title fs-16 pr-2 text-nowrap">Objeto:</div>
                  {source !== 'bulletin' && (
                    <div
                      className="flex-grow-1 fs-16 mb-2"
                      dangerouslySetInnerHTML={{ __html: bidding.objeto || '-' }}
                    />
                  )}
                  {source === 'bulletin' && (
                    <HighlightedText
                      className="flex-grow-1"
                      termsList={bulletins?.filter_bulletins[bulletinFilterIndex]?.bidding_keywords}
                      text={bidding.objeto}
                      removeAcronym
                    />
                  )}
                </div>
              </div>
              <hr />
              <div className="row bidding-info mb-2">
                <div className="col-md-4 d-flex align-items-center">
                  <div className="bidding-info-title mr-2 text-nowrap">Datas:</div>
                  <div className="text-secondary d-flex">
                    <span
                      className={`${
                        (statusTwoDays || statusOneDay) && 'notice-date px-1 text-dark'
                      } ${statusDay && 'bg-danger px-1 text-white'}`}
                    >
                      {!bidding.datahora_abertura &&
                        !bidding.datahora_prazo &&
                        !bidding.datahora_documento &&
                        !bidding.datahora_retirada &&
                        !bidding.datahora_visita &&
                        'Não Informadas'}
                      {bidding.datahora_abertura && (
                        <ImminenceDate
                          date={bidding.datahora_abertura}
                          dateType="Abertura"
                          setStatusTwoDays={setStatusTwoDays}
                          setStatusOneDay={setStatusOneDay}
                          setStatusDay={setStatusDay}
                        />
                      )}
                      {bidding.datahora_prazo && (
                        <ImminenceDate
                          date={bidding.datahora_prazo}
                          dateType="Prazo"
                          setStatusTwoDays={setStatusTwoDays}
                          setStatusOneDay={setStatusOneDay}
                          setStatusDay={setStatusDay}
                        />
                      )}
                      {bidding.datahora_documento && (
                        <ImminenceDate
                          date={bidding.datahora_documento}
                          dateType="Documento"
                          setStatusTwoDays={setStatusTwoDays}
                          setStatusOneDay={setStatusOneDay}
                          setStatusDay={setStatusDay}
                        />
                      )}
                      {bidding.datahora_retirada && (
                        <ImminenceDate
                          date={bidding.datahora_retirada}
                          dateType="Retirada"
                          setStatusTwoDays={setStatusTwoDays}
                          setStatusOneDay={setStatusOneDay}
                          setStatusDay={setStatusDay}
                        />
                      )}
                      {bidding.datahora_visita && (
                        <ImminenceDate
                          date={bidding.datahora_visita}
                          dateType="Visita"
                          setStatusTwoDays={setStatusTwoDays}
                          setStatusOneDay={setStatusOneDay}
                          setStatusDay={setStatusDay}
                        />
                      )}
                    </span>
                    {statusTwoDays && (
                      <span className="title-relogio ml-2"> 2 dias para encerrar</span>
                    )}
                    {statusOneDay && (
                      <span className="title-relogio ml-2"> 1 dia para encerrar</span>
                    )}
                    {statusDay && (
                      <span className="text-danger ml-2 title-danger"> VENCIMENTO HOJE</span>
                    )}
                    {statusTwoDays || statusOneDay ? (
                      <img src={iconClock} alt="icone de relógio" className="ml-2 mb-1" />
                    ) : (
                      ''
                    )}
                  </div>
                </div>
                <div className="col-md-6 d-flex">
                  <div className="bidding-info-title mr-2 text-nowrap">Órgão:</div>
                  <div>
                    {maybeBlur(
                      <button
                        type="button"
                        aria-label="Clique para ver licitações já realizadas por esse órgão."
                        data-balloon-pos="up"
                        className="databalloon btn btn-link p-0 text-left break-text border-0"
                        onClick={() => {
                          setModalOrganDetailsOpened(true);
                          createTrack('Card - Clicou no órgão', { fonte: source });
                        }}
                      >
                        {!bidding?.orgao_uasg && !bidding?.public_body?.nome && '-'}
                        {bidding?.orgao_uasg}
                        {`${bidding.orgao_uasg ? ' - ' : ''}`}
                        {bidding?.public_body?.nome}
                        <i className="material-icons bidding-info-icon ml-1">info</i>
                      </button>,
                    )}
                  </div>
                </div>

                <div className="col-md-2">
                  {(bidding?.electronic_trading?.source_id ?? bidding?.fonte_id) > 0 && (
                    <div
                      className={`d-flex justify-content-md-end ${
                        isOnlyConlicitaseg ? 'locked-actions' : ''
                      }`}
                      aria-disabled={isOnlyConlicitaseg}
                      onClickCapture={blockLocked}
                      onKeyDownCapture={blockLocked}
                    >
                      {bidding?.status_bidding_info?.at(-1)?.url_portal ? (
                        <a
                          href={bidding?.status_bidding_info?.at(-1)?.url_portal}
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label="Acessar local da disputa"
                        >
                          <PortalImage
                            source_id={bidding?.electronic_trading?.source_id ?? bidding?.fonte_id}
                          />
                        </a>
                      ) : (
                        <PortalImage
                          source_id={bidding?.electronic_trading?.source_id ?? bidding?.fonte_id}
                        />
                      )}
                    </div>
                  )}
                </div>
              </div>
              <div className="row bidding-info mb-2 ">
                <div className="col-md-4 d-flex align-items-center">
                  <div className="bidding-info-title text-nowrap mr-2">Cidade:</div>
                  <div className="d-flex align-items-center gap-1">
                    {maybeBlur(
                      <div
                        className="text-secondary"
                        dangerouslySetInnerHTML={{
                          __html: `${bidding.orgao_cidade} - ${bidding.orgao_estado}` || '-',
                        }}
                      />,
                    )}
                    <span
                      className={isOnlyConlicitaseg ? 'locked-actions' : ''}
                      aria-disabled={isOnlyConlicitaseg}
                      onClickCapture={blockLocked}
                      onKeyDownCapture={blockLocked}
                    >
                      <MapLink
                        address={`${bidding.orgao_endereco} ${bidding.orgao_cidade} ${bidding.orgao_estado}`}
                        source={source}
                      />
                    </span>
                  </div>
                  {bidding.public_body?.tem_capag === true &&
                    bidding.public_body?.capag &&
                    bidding.public_body?.capag.capag !== 'N.D.' && (
                      <Capag capag={bidding.public_body.capag} />
                    )}
                </div>
                <div className="col-md-8 d-flex">
                  <div className="bidding-info-title text-nowrap mr-2">Edital:</div>
                  <div
                    className="text-secondary"
                    dangerouslySetInnerHTML={{ __html: `${bidding.edital}` || '-' }}
                  />
                </div>
              </div>
              <div className="row bidding-info">
                {bidding.valor_estimado > 0 && (
                  <div className="col-md-4 d-flex align-items-center mb-2">
                    <div className="bidding-info-title mr-2 text-nowrap">Valor Estimado:</div>
                    <div className="d-flex align-items-center">
                      <span className="estimated px-1 font-weight-bold">{`${bidding?.valor_estimado.toLocaleString(
                        'pt-br',
                        {
                          style: 'currency',
                          currency: 'BRL',
                        },
                      )}`}</span>
                    </div>
                  </div>
                )}
                {bidding?.status_bidding_info?.length > 0 && (
                  <div className="col-md-8 d-flex mb-2">
                    <div className="bidding-info-title text-nowrap mr-2">Link:</div>
                    <div
                      className={`d-flex align-items-center ${
                        isOnlyConlicitaseg ? 'locked-actions' : ''
                      }`}
                      aria-disabled={isOnlyConlicitaseg}
                      onClickCapture={blockLocked}
                      onKeyDownCapture={blockLocked}
                    >
                      <button
                        type="button"
                        className="btn btn-link p-0 break-text border-0"
                        onClick={(event) => {
                          event.preventDefault();
                          createTrack('Card - Clicou Acessar local de disputa', { fonte: source });
                          track('licitacao.viu_local_disputa', { fonte: source });
                          window.open(bidding?.status_bidding_info?.at(-1)?.url_portal, '_blank');
                        }}
                      >
                        Acessar local da disputa
                      </button>
                    </div>
                  </div>
                )}
              </div>
              <div
                className={`bidding-hidden-info d-print-block ${
                  BiddingInfoToggle ? 'd-block' : 'd-none'
                }`}
              >
                <div className="row bidding-info mb-2">
                  <div className="col-md-12 d-flex">
                    <div className="bidding-info-title mr-2 text-nowrap">Processo:</div>
                    <div
                      className="text-secondary"
                      dangerouslySetInnerHTML={{ __html: bidding.processo || '-' }}
                    />
                  </div>
                </div>
                <div className="row bidding-info mb-2">
                  <div className="col-md-12 d-flex">
                    <div className="bidding-info-title mr-2 text-nowrap">Observação:</div>
                    <div className="text-secondary">{bidding.observacao || 'Sem Observação'}</div>
                  </div>
                </div>
                <div className="row bidding-info mb-2">
                  <div className="col-md-4 d-flex">
                    <div className="bidding-info-title mr-2 text-nowrap">Telefone:</div>
                    <div className="text-secondary">
                      {bidding.phones?.length > 0 ? <PhoneCard phones={bidding.phones} /> : '-'}
                    </div>
                  </div>
                  <div className="col-md-8 d-flex">
                    <div className="bidding-info-title mr-2 text-nowrap">Site:</div>
                    <button
                      type="button"
                      className="btn btn-link p-0 border-0 text-left"
                      onClick={(event) => {
                        event.preventDefault();
                        createTrack('Card - Clicou em Site', { fonte: source });
                        window.open(
                          bidding.edital_homepage1.includes('http')
                            ? bidding.edital_homepage1
                            : `http://${bidding.edital_homepage1}`,
                          '_blank',
                        );
                      }}
                    >
                      {bidding.edital_homepage1}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="row d-print-none">
              <div className="col-md-12">
                <button
                  type="button"
                  key="btn-bidding-more-info"
                  className="btn btn-sm btn-link font-weight-bold text-left px-0"
                  disabled={isOnlyConlicitaseg}
                  onClick={() => {
                    setBiddingInfoToggle(!BiddingInfoToggle);
                    BiddingInfoToggle
                      ? createTrack('Card - Clicou Ocultar informações da licitação', {
                          fonte: source,
                        })
                      : createTrack('Card - Clicou Ver mais informações da licitação', {
                          fonte: source,
                        });
                  }}
                >
                  {BiddingInfoToggle ? 'Ocultar' : 'Ver mais informações da licitação'}
                </button>
              </div>
            </div>
            <hr className="mt-2" />
            <div className="row bidding-info mb-3 d-print-none">
              <div className="col-md-12">
                <div className="bidding-info-title mr-2 text-nowrap mb-1">Ações:</div>

                <div
                  className={`d-flex flex-wrap align-items-center gap-2 ${
                    isOnlyConlicitaseg ? 'locked-actions' : ''
                  }`}
                  aria-disabled={isOnlyConlicitaseg}
                  onClickCapture={blockLocked}
                  onKeyDownCapture={blockLocked}
                >
                  {bidding.itens && (
                    <button
                      type="button"
                      className="btn btn-primary btn-sm mr-1 mb-1"
                      onClick={() => {
                        setItemsOpened(!ItemsOpened);
                        createTrack('Card - Clicou em Itens', { fonte: source });
                      }}
                    >
                      Ver itens
                    </button>
                  )}
                  {source !== 'share' && (
                    <BiddingAttachmentList
                      biddingStatusEdital={bidding.edital_status_id}
                      biddingFiles={bidding.edicts}
                      requestEdital={requestEdital}
                      setRequestEdital={setRequestEdital}
                      solicited={solicited}
                      situation={bidding?.bidding_grouping?.descricao}
                      biddingValidade={bidding?.data_validade}
                    />
                  )}
                  {source !== 'share' && (
                    <>
                      {bidding?.has_summary === true && (
                        <BiddingSummaryButton
                          biddingId={
                            source === 'bulletin' || source === 'biddingDetails'
                              ? Number(bidding.bidding_id)
                              : bidding.id
                          }
                          editalDownload={{
                            biddingStatusEdital: bidding.edital_status_id,
                            biddingFiles: bidding.edicts,
                            situation: bidding?.bidding_grouping?.descricao,
                            biddingValidade: bidding?.data_validade,
                          }}
                          capagInfo={{
                            temCapag: bidding.public_body?.tem_capag,
                            capag: bidding.public_body?.capag,
                          }}
                        />
                      )}
                      {bidding?.indexed_for_ai === true && (
                        <BiddingChatButton
                          biddingId={
                            source === 'bulletin' || source === 'biddingDetails'
                              ? Number(bidding.bidding_id)
                              : bidding.id
                          }
                          source={source}
                          editalDownload={{
                            biddingStatusEdital: bidding.edital_status_id,
                            biddingFiles: bidding.edicts,
                            situation: bidding?.bidding_grouping?.descricao,
                            biddingValidade: bidding?.data_validade,
                          }}
                          capagInfo={{
                            temCapag: bidding.public_body?.tem_capag,
                            capag: bidding.public_body?.capag,
                          }}
                        />
                      )}
                    </>
                  )}
                  {source !== 'biddingDetails' && source !== 'share' && (
                    <ManagementButton
                      bidding={bidding}
                      biddingId={Number(bidding.bidding_id) || Number(bidding.id)}
                      setModalManagementTaskOpened={setModalManagementTaskOpened}
                      setTaskType={setTaskType}
                      isManaged={bidding.managed}
                      setModalRemoveBiddingOpened={setModalRemoveBiddingOpened}
                      bulletinId={bulletinFilterId}
                      source={source}
                    />
                  )}
                  {bidding.has_electronic_trading && source !== 'share' && (
                    <MonitoreButton
                      bidding={bidding}
                      isMonitored={bidding.monitored_by_user}
                      biddingId={Number(bidding.bidding_id) || Number(bidding.id)}
                      source={source}
                    />
                  )}
                  {source !== 'share' &&
                    panel.allow_robot &&
                    portals
                      .filter((portal) => ALLOWED_ROBOT_PORTALS.includes(portal.label))
                      .map((portal) => portal.value)
                      .includes(bidding.electronic_trading?.source_id) && (
                      <RobotCreateProposalButton
                        newLaw={_.isNull(bidding?.electronic_trading?.trading_id)}
                        setModalRobotWarningOpened={setModalRobotWarningOpened}
                        bidding={bidding}
                      />
                    )}

                  {source !== 'share' &&
                    panel?.validate_services?.robo &&
                    portals
                      .filter((portal) => ALLOWED_ROBOT_PORTALS.includes(portal.label))
                      .map((portal) => portal.value)
                      .includes(bidding?.electronic_trading?.source_id) && (
                      <RobotCreateProposalButton
                        newLaw={_.isNull(bidding?.electronic_trading?.trading_id)}
                        setModalRobotWarningOpened={setModalRobotWarningOpened}
                        bidding={bidding}
                      />
                    )}
                  {source !== 'share' &&
                    panel?.validate_services?.robo &&
                    profile.alfa_tester &&
                    bidding.electronic_trading?.source_id === 857 && (
                      <RobotCreateProposalButton
                        newLaw={_.isNull(bidding.electronic_trading?.trading_id)}
                        setModalRobotWarningOpened={setModalRobotWarningOpened}
                        bidding={bidding}
                      />
                    )}
                  {'bidding_info' in bidding &&
                    'followups' in bidding &&
                    'contracts' in bidding &&
                    (bidding.bidding_info?.length > 0 ||
                      bidding.followups?.length > 0 ||
                      bidding.contracts?.length > 0) && (
                      <BiddingInfoDropdown
                        bidding_info={bidding?.bidding_info}
                        followup={bidding?.followups}
                        contracts={bidding?.contracts}
                      />
                    )}
                </div>
              </div>
            </div>
            {guaranteeInsurance.show && (
              <BiddingGuaranteeInsurance
                type={guaranteeInsurance.type}
                biddingId={guaranteeInsurance.biddingId}
                showQuoteButton={guaranteeInsurance.showQuoteButton}
              />
            )}
            {requestEdital && (
              <div className="row">
                <div className="col-md-12">
                  <div className="alert alert-warning d-flex px-0" role="alert">
                    {loading ? (
                      <div className="position-relative d-inline-block px-3">
                        Enviando solicitação
                        <SquareLoader customClass="solicited-edital-loading" />
                      </div>
                    ) : (
                      <>
                        <i className="material-icons me-2 text-warning mx-2">report</i>
                        <div>
                          <p className="text-dark mb-2">
                            <strong>Você deseja prosseguir com a solicitação?</strong>
                          </p>
                          <div className="form-check mb-1 text-muted">
                            <input
                              className="form-check-input"
                              type="radio"
                              name={`solicitar_${bidding.bidding_id}`}
                              id={`solicitarSim_${bidding.bidding_id}`}
                              value="sim"
                              onChange={() => handleClickEdital(bidding?.bidding_id)}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`solicitarSim_${bidding.bidding_id}`}
                            >
                              Sim, quero solicitar o edital.
                            </label>
                          </div>
                          <div className="form-check text-muted">
                            <input
                              className="form-check-input"
                              type="radio"
                              name={`solicitar_${bidding.bidding_id}`}
                              id={`solicitarNao_${bidding.bidding_id}`}
                              value="nao"
                              onChange={() => setRequestEdital(false)}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`solicitarNao_${bidding.bidding_id}`}
                            >
                              Não prosseguir.
                            </label>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            )}
            {messageEditalSuccess && (
              <div className="alert alert-success d-flex px-0" role="alert">
                <i className="material-icons me-2 text-success mx-2">check_circle</i>
                <div>
                  <p className="mb-0">
                    <strong>Recebemos sua solicitação!</strong>
                  </p>
                  <p className="mb-0">
                    Estamos tentando contato com o órgão e assim que obtiver a resposta enviaremos
                    no seu e-mail. Caso a resposta não chegue na caixa de entrada, verifique também
                    a caixa de SPAM.
                  </p>
                </div>
              </div>
            )}
            {bidding.itens &&
              ItemsOpened &&
              (source === 'biddings' ||
                source === 'biddingDetails' ||
                source === 'share' ||
                source === 'favorited') && <BiddingItems items={bidding.itens} source={source} />}
            {bidding.itens && ItemsOpened && source === 'bulletin' && (
              <BiddingItems
                items={bidding.itens}
                source={source}
                keywordsList={bulletins?.filter_bulletins[bulletinFilterIndex]?.bidding_keywords}
              />
            )}
            {source !== 'biddingDetails' && <hr />}
            {'highlights_json' in bidding &&
              bidding.highlights_json &&
              bidding?.highlights_json?.highlights?.length > 0 && (
                <>
                  <div className="row mt-2">
                    <div className="col-md-12 bidding-info-title">
                      Palavra-chave encontrada no edital
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 pl-5">
                      <ul className="list-highlight">
                        {bidding?.highlights_json.highlights.map((highlight) => (
                          <li
                            className="item-highlight"
                            dangerouslySetInnerHTML={{ __html: highlight || '-' }}
                          />
                        ))}
                        {bidding?.highlights_json?.count > 5 && (
                          <li>
                            {bidding.highlights_json.count >= 25
                              ? `...e ${bidding.highlights_json.count - 5} ou mais ocorrências`
                              : bidding.highlights_json.count - 5 === 1
                              ? `...e mais ${bidding.highlights_json.count - 5} ocorrência.`
                              : `...e mais ${bidding.highlights_json.count - 5} ocorrências.`}
                          </li>
                        )}
                      </ul>
                    </div>
                  </div>
                  <hr />
                </>
              )}
            {(source === 'biddings' || source === 'bulletin' || source === 'favorited') && (
              <div
                className={isOnlyConlicitaseg ? 'locked-comments' : ''}
                aria-disabled={isOnlyConlicitaseg}
                onClickCapture={blockLocked}
                onKeyDownCapture={blockLocked}
              >
                <BiddingCommentsList
                  biddingId={Number(bidding.bidding_id) || Number(bidding.id)}
                  comments={bidding?.client_comments}
                  bulletinFilterId={bulletinFilterId}
                  source={commentSource}
                />
              </div>
            )}
            <div
              className="d-flex justify-content-between align-items-center border-top pt-2 mt-3 text-secondary flex-column flex-md-row"
              style={{ fontSize: '12px' }}
            >
              <div>
                <span className="number-cnl font-weight-bold">Nº Conlicitação:</span>{' '}
                <span dangerouslySetInnerHTML={{ __html: bidding.bidding_id.toString() || '-' }} />
                <ClipboardIcon
                  value={bidding.bidding_id.toString()}
                  action="Card Licitação - Copiar número conlicitacao"
                />
              </div>
              <div>
                <span>Atualizada em: </span>
                <span>{moment(bidding.modified || '').format('L [às] LT')}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ManagementTask
        modalManagementTaskOpened={modalManagementTaskOpened}
        setModalManagementTaskOpened={setModalManagementTaskOpened}
        bidding={bidding}
        taskType={taskType}
      />
      {modalOrganDetailsOpened && (
        <ModalOrganDetails
          bidding={bidding}
          setModalOrganDetailsOpened={setModalOrganDetailsOpened}
        />
      )}
      <ManagementRemoveBidding
        modalRemoveBiddingOpened={modalRemoveBiddingOpened}
        setModalRemoveBiddingOpened={setModalRemoveBiddingOpened}
        biddingId={Number(bidding.bidding_id) || Number(bidding.id)}
        totalOpenedTaks={totalManagedTasks()}
        source={source}
        bulletinFilterId={bulletinFilterId}
      />
      <RobotComprasnetWarning
        setShowModal={setModalRobotWarningOpened}
        showModal={modalRobotWarningOpened}
      />
    </Container>
  );
};

export default BiddingItemNew;
